import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import ReactDOM from 'react-dom';

import { QaSpecBoolean } from 'pages/qa-spec/components/shared/QaSpecBoolean';
import { transformBooleanToStringQaSpecValue } from 'pages/qa-spec/utils/transformQaBooleanValue';
import { useCallbackRef } from 'hooks';

import './BooleanRadioEditor.less';

export const BooleanRadioEditor = forwardRef((props, ref) => {
  const { value: initValue, column, node } = props;

  const [value, setValue] = useState(initValue);
  const refContainer = useRef(null);

  const focus = useCallbackRef(() => {
    setTimeout(() => {
      let container = ReactDOM.findDOMNode(refContainer.current);

      if (container && container?.focus) {
        container.focus();
      }
    }, [100]);
  });

  useEffect(() => {
    focus();
  }, [focus]);

  useImperativeHandle(ref, () => {
    return {
      getValue() {
        return value;
      },
    };
  });

  const handleChange = (e) => {
    if (e.target.value === 'Yes') {
      setValue(true);
    } else {
      setValue(false);
    }
  };

  const handleInputKeyDown = (e) => {
    e.stopPropagation();
    if (e.key === 'c' || e.key === 'Control') {
      e.preventDefault();
      setValue((prev) => !prev);
    }
  };

  const width = column.getActualWidth() || 300;
  const height = node?.rowHeight || 42;

  return (
    <div
      ref={refContainer}
      className='ag-editor__radio'
      tabIndex={1}
      onKeyDown={handleInputKeyDown}
      style={{ width, height }}
    >
      <QaSpecBoolean
        value={transformBooleanToStringQaSpecValue(value)}
        onChange={handleChange}
      />
    </div>
  );
});
